import * as React from 'react';
import { getStartDate, getEndDate } from '../selectors/getStoreProperties';
import { observer } from 'mobx-react';
import { OwaDate } from 'owa-datetime';
import AutomaticRepliesDateTimePicker from './AutomaticRepliesDateTimePicker';
import strings from 'owa-strings/owa-options-strings';

const styles = require('./AutomaticRepliesDateRangeSelector.scss');

export interface AutomaticRepliesDateRangeSelectorProps {
    isEnabled?: boolean;
    onStartDateSelection?: (startDate: OwaDate) => void;
    onEndDateSelection?: (endDate: OwaDate) => void;
    onStartTimeChanged?: (startTime: OwaDate) => void;
    onEndTimeChanged?: (startTime: OwaDate) => void;
}

@observer
export default class AutomaticRepliesDateRangeSelector extends React.Component<
    AutomaticRepliesDateRangeSelectorProps,
    {}
> {
    render() {
        let startDate = getStartDate();
        let endDate = getEndDate();
        return (
            <div>
                <AutomaticRepliesDateTimePicker
                    pickerStyle={styles.startTimePickerFull}
                    labelStyle={styles.startTime}
                    labelText={strings.options_automaticReplies_emailReplies_startTime}
                    date={startDate}
                    dateSelected={this.startDateSelected}
                    dateAriaLabel={
                        strings.options_automaticReplies_emailReplies_startTime_selectDate
                    }
                    onTimeChanged={this.props.onStartTimeChanged}
                    timeAriaLabel={
                        strings.options_automaticReplies_emailReplies_startTime_selectTime
                    }
                    isEnabled={this.props.isEnabled}
                />
                <AutomaticRepliesDateTimePicker
                    pickerStyle={styles.endTimePickerFull}
                    labelStyle={styles.endTime}
                    labelText={strings.options_automaticReplies_emailReplies_endTime}
                    date={endDate}
                    dateSelected={this.endDateSelected}
                    dateAriaLabel={strings.options_automaticReplies_emailReplies_endTime_selectDate}
                    onTimeChanged={this.props.onEndTimeChanged}
                    timeAriaLabel={strings.options_automaticReplies_emailReplies_endTime_selectTime}
                    isEnabled={this.props.isEnabled}
                />
            </div>
        );
    }

    /**
     * Handler on start date changed
     * @param {OwaDate} date selected date
     */
    startDateSelected = (date: OwaDate) => {
        this.setState({ startDate: date });
        if (!!date && this.props.onStartDateSelection) {
            this.props.onStartDateSelection(date);
        }
    };

    /**
     * Handler on end date changed
     * @param {OwaDate} date selected date
     */
    endDateSelected = (date: OwaDate) => {
        this.setState({ endDate: date });
        if (!!date && this.props.onEndDateSelection) {
            this.props.onEndDateSelection(date);
        }
    };
}
